// removed by extract-text-webpack-plugin
module.exports = {"component":"_3SRo4wlfBRdN-Lbugc2Ku2","tactTitle":"_1_ckotqZHmwKKppZQAXg4o","tactLink":"_3fXnzKMWQUCeWth1F4KkEk","tactTxt":"_2dumvzS0LNcVnm-0meYBLB","childContent":"_2DoJurDw7Hp_P4MnTILyL7"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/LegalStatement/LegalStatement.scss
 ** module id = 1070
 ** module chunks = 0
 **/